import { createMongoAbility } from "@casl/ability";
import { AbilityBuilder } from "@casl/ability";

export const ability = new createMongoAbility();

export function convertAbility(data) {
  const { can, rules } = new AbilityBuilder();
  if (Array.isArray(data)) {
    for (const role of data) {
      can(role?.codename, role?.model);
    }
  }
  return rules;
}

export function updateAbility(data) {
  if (Array.isArray(data)) {
    const rules = convertAbility(data);
    ability.update(rules);
  }
}
